import React from 'react';
import { connect } from 'react-redux';
import HeroSwiper from './HeroSwiper';
import ScrollPrompt from '../ScrollPrompt';
import HeroSwiperSlide from './HeroSwiperSlide';
import { breakpoints } from './../../styles/theme.json';

const Hero = (props) => {
  const heroHeight = {
    height: props.height
  };
  return (
    <section id='hero' style={heroHeight}>
      {(props.video_header_state == 'video-playing') && <div className='block-out'/>}
      {(props.sliderContent.length > 1)
        ? <HeroSwiper slides={props.sliderContent} height={props.height}/>
        : <HeroSwiperSlide slideData={props.sliderContent[0]} height={props.height}/>
      }
      {(props.window_width >= breakpoints.desktop) && <ScrollPrompt />}
      <style jsx>{`
        #hero {
          height: 100vh;
          width: 100%;
          position: relative;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width,
    video_header_state: state.video_state.header_style
  })
)(Hero);



// WEBPACK FOOTER //
// ./src/components/hero/Hero.js